<script setup>
import { ref } from 'vue'
import { fabrics, finishes } from '@/data/catalog'
import FabricSwatch from '@/components/FabricSwatch.vue'
import FabricDialog from '@/components/FabricDialog.vue'

defineProps({
  phone: { type: String, required: true }
})

const openFabric = ref(null)
</script>

<template>
  <section id="telas" class="bg-tobacco scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <header class="max-w-2xl">
        <h2 class="display text-[clamp(1.9rem,4vw,3rem)] text-linen">Telas</h2>
        <p class="mt-3 leading-relaxed text-linen/60">
          Elige la tela que más te guste y que mejor se adapte a lo que necesitas. Todas nuestras telas son de alta calidad.
          Toca una para verla de cerca y ver sus colores.
        </p>
      </header>

      <ul class="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-x-6 lg:mt-12 lg:grid-cols-5 lg:gap-6">
        <li v-for="fabric in fabrics" :key="fabric.name">
          <button
            type="button"
            class="group flex w-full flex-col text-start"
            :aria-label="`Ver la tela ${fabric.name}`"
            @click="openFabric = fabric"
          >
            <div class="relative overflow-hidden rounded-md ring-1 ring-inset ring-linen/10">
              <FabricSwatch :fabric="fabric" />
              <div
                class="pointer-events-none absolute inset-0 flex items-center justify-center bg-night/70 opacity-0 transition-opacity duration-500 ease-soft group-hover:opacity-100 group-focus-visible:opacity-100"
                aria-hidden="true"
              >
                <span
                  class="inline-flex scale-95 items-center gap-2 rounded-full bg-night px-4 py-3 text-sm font-semibold text-linen shadow-xl shadow-night/50 ring-1 ring-inset ring-linen/15 transition-transform duration-500 ease-soft group-hover:scale-100 group-focus-visible:scale-100"
                >
                  <svg viewBox="0 0 24 24" fill="none" class="h-5 w-5" aria-hidden="true">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
                    <path d="m16.5 16.5 4 4M11 8v6M8 11h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  Ver detalles
                </span>
              </div>
            </div>

            <h3 class="display mt-3 text-lg text-linen sm:mt-4 sm:text-xl">{{ fabric.name }}</h3>
            <p class="mt-1 text-sm leading-relaxed text-linen/70">{{ fabric.note }}</p>
          </button>
        </li>
      </ul>
    </div>

    <FabricDialog :fabric="openFabric" :phone="phone" @close="openFabric = null" />
  </section>
</template>
